// TODO: Restrict the signature of the t function to only accept keys with explicit namespaces
import { TFunction, t as importedTFn } from 'i18next';
import { useTranslation as importedHook } from 'react-i18next';

type TranslationKey = `${string}:${string}`;

export const useTranslation = (ns: string) => importedHook<string>(ns);
export const t: TFunction<string> = importedTFn;
